export default __webpack_public_path__ + "./fonts/filter.378349ea1dffe873f2c95f87cccb795c.svg";